export class Localidade {
  ativo: boolean;
  id: number;
  tipoLocalidadeId: number;
  localidade: string;
  codigoUnidadeOrcamentaria: string;
  enderecoId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/shared/localidade.model.ts
 **/